import { render, staticRenderFns } from "./HandicapChart.vue?vue&type=template&id=5d47d4e8&scoped=true"
import script from "./HandicapChart.vue?vue&type=script&lang=js"
export * from "./HandicapChart.vue?vue&type=script&lang=js"
import style0 from "./HandicapChart.vue?vue&type=style&index=0&id=5d47d4e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d47d4e8",
  null
  
)

export default component.exports